var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.path !== '/login')?_c('div',[_c('toolbar')],1):_vm._e(),_c('v-content',[_c('v-container',{staticClass:"fluid"},[_c('router-view'),_c('TheAdminLink')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }